import Moment from 'moment';
import QueryString from 'query-string';

export const toExclusiveDate = (value: Date | undefined) => Moment(value).add(1, 'days').toDate();

export const parseFilterFromQueryString = (urlLocation: Location | undefined, urlDateFormat: string | undefined) => {
    if(!urlLocation || urlLocation.search.length === 0)
        return { from: undefined, to: undefined, valid: false };
    const params = QueryString.parse(urlLocation.search) as { from: string | undefined; to: string | undefined; valid: string | undefined };

    const parseDate = (date: string | undefined) => !date || date.length === 0 ? undefined : Moment(date, urlDateFormat).toDate();
    return {
        from: parseDate(params.from),
        to: parseDate(params.to),
        valid: params.valid === 'true' || params.valid === undefined
    };
};
